import { render, staticRenderFns } from "./TsAssirete.vue?vue&type=template&id=609318db&scoped=true"
import script from "./TsAssirete.vue?vue&type=script&lang=js"
export * from "./TsAssirete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609318db",
  null
  
)

export default component.exports